<template>
  <v-card>
    <v-toolbar
      class="text-h6 mx-1 mb-3"
      :class="darkMode ? '' : 'mt-1'"
      style="width: 61.6vw"
    >
      Payment Review
    </v-toolbar>
    <unit-plan-summary />
  </v-card>
</template>

<script>
import UnitPlanSummary from "@/modules/accounts-receivable/components/UnitPlanSummary";
import { mapState } from "vuex";
export default {
  name: "PlanReview",

  components: {
    UnitPlanSummary
  },

  computed: {
    ...mapState({
      darkMode: state => state.application.settings.darkTheme
    })
  }
};
</script>
